import {Badge, BadgeSizeType} from 'platform/components';
import {HStack, Integer, Text, TextSize} from 'platform/foundation';

import i18n from '@dms/i18n';
import {SkeletonLoadingBox} from '@dms/shared';

import {TestIdProps, suffixTestId} from 'shared/web';

import {WORKSHOP_SECTION_APPEARANCE} from '../constants/workshopSectionAppearance';
import {WorkshopOverviewDensity} from '../types/WorkshopOverviewDensity';
import {WorkshopOverviewTileState, WorkshopSection} from '../types/WorkshopOverviewTileConfig';
import {getWorkshopSectionTotal} from '../utils/getWorkshopSectionTotal';

interface WorkshopOverviewSectionLabelProps extends TestIdProps {
  section: WorkshopSection;
  tiles: WorkshopOverviewTileState[];
  isLoading: boolean;
  density: WorkshopOverviewDensity;
}

interface WorkshopOverviewSectionLabelLayout {
  textSize: TextSize;
  badgeSize: BadgeSizeType;
  skeletonSide: Integer;
}

const LABEL_LAYOUT: Record<WorkshopOverviewDensity, WorkshopOverviewSectionLabelLayout> = {
  comfortable: {textSize: 'small', badgeSize: 'default', skeletonSide: 6},
  compact: {textSize: 'xSmall', badgeSize: 'small', skeletonSide: 4},
};

export function WorkshopOverviewSectionLabel(props: WorkshopOverviewSectionLabelProps) {
  const appearance = WORKSHOP_SECTION_APPEARANCE[props.section];
  const layout = LABEL_LAYOUT[props.density];

  return (
    <HStack spacing={2} align="center">
      <Text size={layout.textSize} alternative noWrap>
        {i18n.t(appearance.titleKey)}
      </Text>
      <SkeletonLoadingBox
        key={props.isLoading ? 'loading' : 'count'}
        width={layout.skeletonSide}
        height={layout.skeletonSide}
        borderRadius="small"
        backgroundColor={appearance.skeletonColor}
        isLoading={props.isLoading}
      >
        <Badge
          size={layout.badgeSize}
          colorScheme={appearance.badgeColorScheme}
          value={getWorkshopSectionTotal(props.tiles)}
          data-testid={suffixTestId('workshopOverviewSectionBadge', props)}
        />
      </SkeletonLoadingBox>
    </HStack>
  );
}
